import { useMemo } from 'react';

import {
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { useParams } from 'react-router';
import { parseAsStringLiteral, useQueryState } from 'nuqs';

import { useGetAssignments } from '../../../query/assignment';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import DataTable from '../data-table';
import { ASSIGNMENT_COLUMNS } from './assignment-columns';
import AssignmentPhaseTabs from './assignment-phase-tabs';

const PHASE_VALUES = ['notStarted', 'inProgress', 'completed'];

const AssignmentTable = () => {
  const { courseId } = useParams<{ courseId: string }>();

  const [phase] = useQueryState(
    'phase',
    parseAsStringLiteral(PHASE_VALUES).withDefault('inProgress'),
  );

  const { data: assignments } = useGetAssignments({ courseId: courseId!, phase });
  const tableData = useMemo(() => {
    if (!assignments) return [];
    if (!assignments.data) return [];
    return assignments.data;
  }, [assignments]);

  const table = useReactTable({
    data: tableData,
    columns: ASSIGNMENT_COLUMNS,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    meta: {
      phase,
    },
  });

  return (
    <div className="flex flex-col gap-4">
      <AssignmentPhaseTabs />
      <Card className="bg-white">
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>과제</CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable table={table} />
        </CardContent>
      </Card>
    </div>
  );
};

export default AssignmentTable;
